module.exports = __webpack_public_path__ + "static/media/ozenMain.6878334d.jpg";